import { defineComponent, onMounted } from 'vue';
import CatalogItem from '@/components/CatalogItem.vue';
import CircularSpinner from '@/components/CircularSpinner.vue';
import { useCatalog } from '@/catalog';
export default defineComponent({
    name: 'SimpleCatalog',
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
    components: {
        CircularSpinner,
        CatalogItem,
    },
    setup(props) {
        const { products, loadingProducts, getProductQuery, getCatalogQuery, loadProducts, addToCart, viewDetails, } = useCatalog(props.config);
        onMounted(() => {
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            loadProducts(catalogQuery);
        });
        return {
            loadingProducts,
            products,
            addToCart,
            viewDetails,
        };
    },
});
